import { Container } from "react-bootstrap";

const FormSubmitted = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Container className="text-center">
        <h1 className="fw-bold text-success mb-3">
          Thank you for submitting the form!
        </h1>
        <p className="text-muted">
          If you have already submitted, no further action is needed.
        </p>
        <p className="text-muted">
          If this is your first time, our team will contact you soon.
        </p>
      </Container>
    </div>
  );
};

export default FormSubmitted;
